import axios from "axios";
import qs from "qs";
const request = axios.create({
  baseURL: "https://nspcapi.heimatianqi.com",
  timeout: 300000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
  transformRequest: [
    (data, headers) => {
      let userinfo = JSON.parse(localStorage.getItem("user") || "{}");
      if (userinfo.token) {
        headers.Authorization = `Bearer ${userinfo.token}`;
      }
      if (headers["Content-Type"] === "application/x-www-form-urlencoded") {
        return qs.stringify(data);
      }
      if (headers["Content-Type"] === "multipart/form-data") {
        return data;
      }
      return JSON.stringify(data);
    },
  ],
});
request.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
request.interceptors.response.use(
  (response) => {
    try {
      return response?.data;
    } catch (error) {
      console.error("Error handling response:", error);
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
export { request };
